module.exports = __webpack_public_path__ + "static/media/OldTestament_desc.a0c92b8e.png";